import React, { useEffect } from "react";
import Meta from "../../components/Meta";
import CreateGift from "../../components/trading/form_invoice"



const Trading = () => {
  return (
    <>
      <Meta title="비트코인 기프트콘 만들기" 
      desc={"비트코인, lightning network"} keyword={""}
      />
      <CreateGift></CreateGift>

    </>
  );
};

export default Trading;
